import { ReactComponent as IconRemoveDataElement } from "@/assets/svgs/icon-remove-data-element.svg";
import { ReactComponent as IconClose } from "@/assets/svgs/icon-close.svg";
import Modal from "@/componentsDS/Modal/Modal";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Button from "@/components/Button";
import rem from "@/utils/rem";


export function CompanyExists({ setMessage, message }) {
	const pending = message?.includes('pending');
	const enrolled = message?.includes("sure organization is not already enrolled");
	const title = `Company ${pending?'Application':'Account'} Already Exists`;
	const visible = message?.length>0 && (pending || enrolled);
	return (
		<Modal visible={visible} close={setMessage} variant="medium">
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon--error'}>
										<IconRemoveDataElement />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										<span className="t--red">{title}</span>
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div
							style={{
								fontSize: rem(14),
								textAlign: "center",
							}}
						>
							<p className="message">{message}</p>
							<a href="https://support.sqtradex.com/">
								https://support.sqtradex.com/
							</a>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button
							className="button--ghost"
							style={{ width: rem(80), marginLeft: rem(10) }}
							text="Okay, Got it"
							submit={setMessage}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	);
}
